<template>
    <div class="document-picker">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-6">
                    <custom-multi-select
                            class="document-picker__multi-select"
                            :options="options"
                            :selected-options="items"
                            hide-selected-options
                            @select="selectItem"
                    >
                    </custom-multi-select>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <ul class="document-picker__list">
                        <li v-for="item in items" :key="item.value"
                            class="document-picker__list-item">
                            <button type="button"
                                    class="document-picker__close-button btn btn-link"
                                    @click="deleteItem(item)">
                                <i class="fa fa-close"></i>
                            </button>
                            <span>{{ item.text }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { PRODUCTS_CHANGED } from "../../store/mutations.type"
    import CustomMultiSelect from './CustomMultiSelect'

    export default {
        name: 'DocumentPicker',
        components: {
            CustomMultiSelect
        },
        data() {
            return {
                options: [],
                items: []
            }
        },
        computed: {
            ...mapGetters("myAdmin", ["productOptions", "currentProducts"]),
        },
        watch: {
            items: function (newValue) {
                this.$store.commit('myAdmin/' + PRODUCTS_CHANGED, newValue);
            },
            productOptions: function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.options = newValue;
                }
            },
            currentProducts: function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.items = newValue;
                }
            }
        },
        methods: {
            selectItem(items) {
                this.items = items;
            },
            deleteItem(deleteItem) {
                this.items = this.items.filter(item => item !== deleteItem)
            }
        }
    }
</script>

<style lang="scss">
    .document-picker {
        display: flex;
        //border: 1px #00a4e4 solid;

        .document-picker__multi-select.document-picker__multi-select.document-picker__multi-select {
            border-radius: 0;
            .menu {
                border-radius: 0;
            }
            .ui.label {
                color: #ffffff;
                border-radius: 0;
                background-color: #00a8e1;
                box-shadow: none;
                font-weight: normal;
                i.icon.delete:before,i.icon.delete:after {
                    background-color: #ffffff;
                }
            }

        }
        .document-picker__list-item {
            list-style: none;
            display: flex;
            align-items: center;
        }

        .document-picker__list {
            border: 1px solid rgba(34,36,38,.15);
            height: 55vh;
            max-height: 55vh;
            padding: 0;
            overflow-y: scroll;
            //min-width: 300px;
        }


    }
</style>